import moment from "moment";
import { User } from "./user.model";

export class MarketingTemplate {
	pk: string; //venueKey
	sk: string; //:UUID
	name: string;
	description: string;
	subject: string;
	created: string = moment().format();
	modified: string = moment().format();
	deleted: string;
	authorUserKey: string;
	sendCount: number;
	openCount: number;
	firstSend: string;
	lastSend: string;

	authorUser: User;

	public constructor(init?: Partial<MarketingTemplate>) {
		Object.assign(this, init);
	}
}
